import React, { useRef } from "react";
import { Chip } from "@mui/material";
import CustomCheckbox from "./CustomCheckbox";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import "../../../assets/styles/containers/_commentFilter.scss";
import { Paper, Box, TextField, Typography } from "@mui/material";

function FilterTags(props) {
  const { filterTagList, filterType, GetCommentList, selectedFilterTagID: propSelectedIds, selectedIDs, setSelectedFilterTagID, setState, state, onUpdate } = props;
  const scrollTopRef = useRef(0);

  const selectedFilterTagID = propSelectedIds || state?.selectedFilterTagID || [];

  function CustomPaper({ children }) {
    return (
      <Paper
        sx={{
          "& .MuiAutocomplete-listbox": { "& .MuiAutocomplete-option[aria-selected='true']": { bgcolor: "white", "&.Mui-focused": { bgcolor: "white", }, }, },
          "& .MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused": { bgcolor: "white" },
          border: "1px solid #D5D5D5",
          borderRadius: "4px",
        }}
      >
        {children}
      </Paper>
    );
  }

  return (
    <Autocomplete
      multiple
      size="small"
      options={filterTagList || []}
      value={filterTagList?.filter((tag) => (selectedFilterTagID || selectedIDs)?.includes(tag?.id)) || []}
      id="multiple-limit-tags"
      PaperComponent={CustomPaper}
      className="filter-tags-textfield"
      disableCloseOnSelect
      autoHighlight={false}
      componentsProps={{ popper: { sx: { zIndex: 100000 } } }}
      ListboxProps={{
        style: { maxHeight: 300, overflow: "auto" },
        ref: (el) => {
          if (el) {
            el.scrollTop = scrollTopRef.current;
          }
        },
        onScroll: (event) => {
          scrollTopRef.current = event.target.scrollTop;
        },
      }}
      onChange={(e, value) => {
        const selectedIds = value?.map((item) => item?.id)?.filter((id) => id !== undefined);
        GetCommentList?.({ filterByTagId: selectedIds, filterByType: filterType }, "filter");
        if (onUpdate) onUpdate(selectedIds);
        else if (setState) setState((prevState) => ({ ...prevState, selectedFilterTagID: selectedIds, page: 0, }));
        else setSelectedFilterTagID(selectedIds);
      }}
      getOptionLabel={(option) => {return option?.name || option?.title}}
      sx={{ ml: "8px", "& .MuiOutlinedInput-root": { flexWrap: "wrap", height: 37, alignItems: "center" } }}
      renderTags={(value, getTagProps) => {
        const visible = value?.slice(0, 1);
        const hiddenCount = value?.length - visible?.length;
        return (
          <>
            {visible?.map((option, index) => (
              <Chip
                key={option?.id ?? `${option}-${index}`}
                size="small"
                style={{
                  borderRadius: "35px",
                  border: "1px solid #CED2DA",
                  backgroundColor: option?.color,
                  color: (option?.color === "#FFFFFF !important" || option?.color?.toLowerCase() === "white !important") ? "#000 !important" : "#FFFFFF !important"
                }}
                deleteIcon={
                  <div style={{
                    backgroundColor: "#black",
                    borderRadius: "50%",
                    height: "16px",
                    width: "16px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  >
                    <CloseIcon style={{ color: "white", height: "14px", width: "14px" }} />
                  </div>
                }
                label={<span className="filter-tags-lable">{option.name || option.title}</span>}
                {...getTagProps({ index })}
              />
            ))}
            {hiddenCount > 0 && (
              <Typography sx={{ ml: 0.5 }}>{`+${hiddenCount}`}</Typography>
            )}
          </>
        );
      }}
      renderOption={(props, option, { selected }) => {
        return (
          <li {...props} key={option?.id}>
            <Box display={"flex"} gap={"8px"} alignItems="center">
              <CustomCheckbox checked={selected} />
              <Box
                sx={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: option?.color,
                  borderRadius: "50%",
                  flexShrink: 0,
                }}
              />
              <Typography
                color={"text.primary"}
                style={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  wordBreak: "break-word",
                }}
              >
                {option.name || option.title}
              </Typography>
            </Box>
          </li>
        );
      }}
      renderInput={(params) => <TextField size="small" {...params} placeholder={params?.inputProps?.value?.length === 0 && selectedFilterTagID?.length === 0 ? "Filter by tags" : ""} />}
    />
  );
}

export default FilterTags;